import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { ShareBold, Share1Light } from '@ha/icons';
import { RoundIconButtonProps, RoundIconButton } from 'ha/ui/RoundIconButton';

import { usePageRedesign } from '../hooks/usePageRedesign';

const useStyles = makeStyles()(theme => ({
  icon: {
    color: theme.palette.grey[700],
  },
}));

export const ListingShareButton: React.FC<
  Omit<RoundIconButtonProps, 'children'>
> = React.forwardRef((props, ref) => {
  const { T } = useIntl();
  const { classes } = useStyles();
  const withPageRedesign = usePageRedesign();

  return (
    <RoundIconButton
      aria-label={T('Share')}
      title={T('Share')}
      color="white"
      size="small"
      {...props}
      ref={ref}
    >
      {withPageRedesign ? (
        <Share1Light fontSize="small" className={classes.icon} />
      ) : (
        <ShareBold color="action" fontSize="small" />
      )}
    </RoundIconButton>
  );
});

ListingShareButton.displayName = 'ListingShareButton';
